import { post, get } from "./methods";
// 登录
export const login = <T = any>(params: any) => post<T>('/api/mr/user/login', params)
// 退出
export const logout = <T = any>() => post<T>('/api/mr/user/logout')
// 注册
export const register = <T = any>(params: any) => post<T>('/api/mr/user/register', params)
// 忘记密码
export const forgetPwd = <T = any>(params: any) => post<T>('/api/mr/user/resetPassword', params)
// 验证码
export const getQrCode = <T = any>(params: any) => post<T>(`/api/mr/user/sendSms/${params}`)
// 我的上产
export const myUpload = <T = any>() => get(`/api/mr/material/self`);